import { Col, Row } from 'reactstrap';
import { useIntl } from 'react-intl';
import { capitalizeFirstLetter } from 'src/utils/string';
import Input from 'src/componentes/input';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import Checkbox from 'src/componentes/checkbox';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import useAuth from 'src/hooks/useAuth';
import { DateRangePicker } from 'src/componentes/Form';
import InputNumber from 'src/componentes/input-number';
import StatusPerdaOperacionalLookup from 'src/lookups/status-perda-operacional';
import DesenharCampoCustomizado from 'src/paginas/item/campo-customizado/componentes/desenhar';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';

const PerdaOperacionalSearch = ({ model }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const handleChangePeriodo = (start, end) => {
    model.getModel('dataInicioRegistro').requestChange(start);
    model.getModel('dataTerminoRegistro').requestChange(end);
  };

  const handleChangePeriodoPerda = (start, end) => {
    model.getModel('dataInicioPerda').requestChange(start);
    model.getModel('dataTerminoPerda').requestChange(end);
  };

  return (
    <>
      <CollapsibleSection
        title={intl.formatMessage({ id: 'label.informacoesBasicas' })}
        startOpen
      >
        <Row>
          <Col md={12}>
            <Input model={model.getModel('idIntegracao')} />
          </Col>
          <Col md={12}>
            <Input model={model.getModel('nome')} />
          </Col>
          <Col md={12}>
            <StatusPerdaOperacionalLookup
              multi={true}
              clearable
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'status' })
                ),
                value: model.getModel('statusPerdaOperacionalList').value,
                requestChange: model.getModel('statusPerdaOperacionalList')
                  .requestChange,
              }}
            />
          </Col>
          <Col md={12}>
            <ItemOrganizacaoLookup
              multi
              model={{
                label: capitalizeFirstLetter(resources.areas),
                value: model.getModel('areas').value,
                requestChange: model.getModel('areas').requestChange,
              }}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
              clearable
            />
          </Col>
          <Col md={12}>
            <Checkbox
              model={{
                label: intl.formatMessage(
                  { id: 'label.considerarAreasSubordinadas' },
                  { areas: resources.areas }
                ),
                value: model.getModel('areasSubordinadas').value,
                requestChange:
                  model.getModel('areasSubordinadas').requestChange,
              }}
              className="mb-3"
            />
          </Col>
          <Col md={12}>
            <ColaboradorEGrupoSimplificadoLookup
              multi
              abrirEmDrawer={true}
              labelComoTitulo
              data={{ somenteAtivos: true }}
              model={{
                label: capitalizeFirstLetter(resources.responsaveis),
                requestChange: model.getModel('responsaveisSimplificado')
                  .requestChange,
                value: model.getModel('responsaveisSimplificado').value,
              }}
            />
          </Col>

          <Col md={12}>
            <Input
              type="textarea"
              rows={3}
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'descricao' })
                ),
                requestChange: model.getModel('descricao').requestChange,
                value: model.getModel('descricao').value,
              }}
            />
          </Col>
          <Col md={12}>
            <div className="mb-2">
              {capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelPeriodoDataRegistro' })
              )}
            </div>
            <DateRangePicker
              startValue={model.getModel('dataInicioRegistro').value}
              endValue={model.getModel('dataTerminoRegistro').value}
              onChange={handleChangePeriodo}
              placeholderStart={intl.formatMessage({ id: 'dataInicio' })}
              placeholderEnd={intl.formatMessage({ id: 'dataTermino' })}
            />
          </Col>
          <Col md={12}>
            <div className="mb-2">
              {capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelPeriodoDataPerda' })
              )}
            </div>
            <DateRangePicker
              startValue={model.getModel('dataInicioPerda').value}
              endValue={model.getModel('dataTerminoPerda').value}
              onChange={handleChangePeriodoPerda}
              placeholderStart={intl.formatMessage({ id: 'dataInicio' })}
              placeholderEnd={intl.formatMessage({ id: 'dataTermino' })}
            />
          </Col>
          <Col md={12}>
            <InputNumber
              precision={2}
              model={{
                label: intl.formatMessage({ id: 'labelValorPerdaPartirDe' }),
                value: model.getModel('valorPerdaApartirDe').value,
                requestChange: (v) =>
                  model.getModel('valorPerdaApartirDe').requestChange(v),
                errors: model.getModel('valorPerdaApartirDe').errors,
              }}
            />
          </Col>
        </Row>
      </CollapsibleSection>
      <CollapsibleSection
        title={intl.formatMessage({ id: 'informacoesDeOrigem' })}
      >
        <Row>
          <Col md={12}>
            <ItemOrganizacaoLookup
              multi
              model={{
                label: intl.formatMessage({ id: 'areasGeradoras' }),
                value: model.getModel('areasGeradoras').value,
                requestChange: model.getModel('areasGeradoras').requestChange,
              }}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
              clearable
            />
          </Col>
          <Col md={12}>
            <ColaboradorEGrupoSimplificadoLookup
              multi
              abrirEmDrawer={true}
              labelComoTitulo
              model={{
                label: intl.formatMessage({ id: 'responsaveisPelaAnalise' }),
                requestChange: model.getModel('responsaveisAnalise')
                  .requestChange,
                value: model.getModel('responsaveisAnalise').value,
              }}
              data={{ somenteAtivos: true }}
            />
          </Col>
        </Row>
      </CollapsibleSection>
      {model.getModel('camposCustomizados')?.value?.length > 0 && (
        <CollapsibleSection
          title={intl.formatMessage({ id: 'informacoesComplementares' })}
        >
          <Row>
            <Col md={12}>
              <DesenharCampoCustomizado
                model={model.getModel('camposCustomizados')}
                mdFields={12}
              />
            </Col>
          </Row>
        </CollapsibleSection>
      )}
    </>
  );
};
export default PerdaOperacionalSearch;
